<template>
  <div
    v-if="filters.length > 0"
    class="filters-container"
  >
    <v-menu
      v-model="filtersMenuOpened"
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          dark
          small
          v-on="on"
        >
          {{ $t('Filters') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-layout
            row
            wrap
          >
            <v-select
              v-model="newFilter"
              :items="remainingFilters"
              :label="$t('Select filter')"
              return-object
              full-width
              item-text="label"
            />
            <v-btn
              @click="addFilter"
            >
              {{ $t('Add') }}
            </v-btn>
          </v-layout>
          <component
            v-for="(filter, index) in stagedFilters"
            v-if="filter.type !== 'hidden'"
            :key="index"
            :is="filter.type + '-filter'"
            :filter="filter"
            @update="stagedFilters[index] = $event"
            @delete="removeFilter(index)"
          />
          <v-btn
            v-if="stagedFilters.length > 0"
            color="default"
            @click="clearFilters"
          >
            {{ $t('Clear Filters') }}
          </v-btn>

          <v-btn
            color="primary"
            class="right"
            @click="submit"
          >
            {{ $t('Submit') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import NumberFilter from './NumberFilter'
import StringFilter from './StringFilter'
import MoneyFilter from './MoneyFilter'
import { mapGetters } from 'vuex'

export default {
  name: 'CollectionFilters',

  components: {
    DateFilter,
    NumberFilter,
    StringFilter,
    MoneyFilter
  },

  props: {
    filters: {
      type: Array,
      default: () => []
    },

    activeFilters: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      newFilter: null,
      stagedFilters: [],
      filtersMenuOpened: false
    }
  },

  computed: {
    ...mapGetters(['currency']),

    remainingFilters () {
      let filteredFields = this.stagedFilters.map(item => item.field)
      return this.filters.filter(item => !filteredFields.includes(item.field))
    }
  },

  watch: {
    activeFilters (filters) {
      this.stagedFilters = JSON.parse(JSON.stringify(filters))
    }
  },

  methods: {
    clearFilters () {
      this.stagedFilters = []
      this.$emit('filters-cleared')
      this.filtersMenuOpened = false
    },

    addFilter () {
      if (this.newFilter === null) {
        return
      }

      this.stagedFilters.push({
        field: this.newFilter.field,
        parentField: this.newFilter.parentField,
        label: this.newFilter.label,
        type: this.newFilter.type,
        operator: null,
        value: null
      })

      this.newFilter = null
    },

    removeFilter (index) {
      this.stagedFilters.splice(index, 1)
    },

    submit () {
      let formattedFilters = []

      this.stagedFilters.forEach((filter) => {
        if (filter.type === 'money') {
          formattedFilters.push({ field: filter.parentField + '.currency',
            parentField: filter.parentField,
            type: 'hidden',
            operator: 'eq',
            value: this.currency })
        }

        formattedFilters.push(filter)
      })

      this.$emit('filters-submitted', formattedFilters)
      this.filtersMenuOpened = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .filters-container {
    width: auto;
    display: inline-block;

    .v-menu {
      display: inline-block;
    }
  }
  .v-card__text {
    overflow: hidden
  }
</style>
